<div class="error-modal" [@modalFade]="animationState" (@modalFade.done)="onAnimationDone($event)">
  <div class="error-modal__header">
    <div class="error-modal__header-inner">
      <div class="error-modal__icon" aria-hidden="true">
        <lucide-icon name="circle-alert" [size]="28" class="error-modal__icon-svg"></lucide-icon>
      </div>
      <h2 class="error-modal__title">{{ 'ERROR_MODAL.HEADING' | translate }}</h2>
    </div>
    <button type="button" class="error-modal__close" (click)="close()" aria-label="Close">
      <lucide-icon name="x" [size]="20"></lucide-icon>
    </button>
  </div>

  <div class="error-modal__content">
    <div class="error-modal__message-hero">
      <div class="error-modal__message-content">
        @for (line of messageLines; track $index) {
          <p class="error-modal__message-line">{{ line }}</p>
        } @empty {
          <p class="error-modal__message-line">{{ 'ERROR_MODAL.NO_MESSAGE' | translate }}</p>
        }
      </div>
    </div>

    <div class="error-modal__technical">
      <button
        type="button"
        class="error-modal__technical-trigger"
        [attr.aria-expanded]="technicalDetailsOpen"
        [attr.aria-controls]="'error-technical-details'"
        [id]="'error-technical-trigger'"
        (click)="toggleTechnicalDetails()"
      >
        <span class="error-modal__technical-label">{{
          'ERROR_MODAL.TECHNICAL_DETAILS' | translate
        }}</span>
        <lucide-icon
          name="chevron-down"
          [size]="18"
          class="error-modal__technical-chevron"
          [class.error-modal__technical-chevron--open]="technicalDetailsOpen"
        ></lucide-icon>
      </button>
      @if (technicalDetailsOpen) {
        <div
          id="error-technical-details"
          class="error-modal__technical-panel"
          role="region"
          [attr.aria-labelledby]="'error-technical-trigger'"
        >
          <div class="error-modal__technical-grid">
            <div class="error-modal__block">
              <span class="error-modal__label">{{ 'ERROR_MODAL.STATUS' | translate }}</span>
              <span class="error-modal__value"
                >{{ payload.statusCode }} {{ payload.statusText ?? '' }}</span
              >
            </div>
            @if (payload.errorCode) {
              <div class="error-modal__block">
                <span class="error-modal__label">{{ 'ERROR_MODAL.ERROR_CODE' | translate }}</span>
                <span class="error-modal__value error-modal__value--code">{{
                  payload.errorCode
                }}</span>
              </div>
            }
            @if (payload.path) {
              <div class="error-modal__block error-modal__block--full">
                <span class="error-modal__label">{{ 'ERROR_MODAL.PATH' | translate }}</span>
                <span class="error-modal__value error-modal__value--path">{{ payload.path }}</span>
              </div>
            }
            @if (payload.timestamp) {
              <div class="error-modal__block">
                <span class="error-modal__label">{{ 'ERROR_MODAL.TIMESTAMP' | translate }}</span>
                <span class="error-modal__value">{{ payload.timestamp }}</span>
              </div>
            }
          </div>
          @if (payload.extra && objectKeys(payload.extra).length > 0) {
            <div class="error-modal__block">
              <span class="error-modal__label">{{ 'ERROR_MODAL.DETAILS' | translate }}</span>
              <pre class="error-modal__extra">{{ payload.extra | json }}</pre>
            </div>
          }
        </div>
      }
    </div>
  </div>

  <div class="error-modal__footer">
    <lib-button variant="primary" type="button" (onClick)="close()">
      {{ 'ERROR_MODAL.CLOSE' | translate }}
    </lib-button>
  </div>
</div>
